import { render } from "./UserAssists.vue?vue&type=template&id=3e09f856"
import script from "./UserAssists.vue?vue&type=script&lang=js"
export * from "./UserAssists.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__